export const handleGridStyles = (
  breakpoints: {
    name: string;
    breakPoint: number;
  }[],
  breakpointsExtension: string
): void => {
  const style = document.createElement("style");
  style.innerHTML = generateStyle(breakpoints, breakpointsExtension);
  document.head.appendChild(style);
};

export const generateStyle = (
  breakpoints: {
    name: string;
    breakPoint: number;
  }[],
  breakpointsExtension: string
): string => {
  let result = `
@charset "UTF-8"; 
.row {
  --grid-gutter-lr: 15px;
  --grid-gutter-tb: 0;
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: calc(var(--grid-gutter-lr) * -1);
  margin-left: calc(var(--grid-gutter-lr) * -1);
  margin-top: calc(var(--grid-gutter-tb) * -1);
  margin-bottom: calc(var(--grid-gutter-tb) * -1);
}
.row.reverse {
  flex-direction: row-reverse;
}
.col {
  box-sizing: border-box;
  flex: 0 0 auto;
  padding-right: var(--grid-gutter-lr);
  padding-left: var(--grid-gutter-lr);
  padding-top: var(--grid-gutter-tb);
  padding-bottom: var(--grid-gutter-tb);
}
`;

  breakpoints.forEach(({ name, breakPoint }) => {
    const z = breakPoint === 0;
    const styleRow = generateStyleRow(name);
    result += `${
      z
        ? ""
        : `@media screen and (min-width: ${breakPoint}${breakpointsExtension}) {`
    } ${styleRow} ${z ? "" : "}"}`;
  });

  return result;
};

// TODO: move "columns" to app config
const generateStyleRow = (name: string, columns = 12): string => {
  let res = `
  .col-${name} {flex-grow: 1;flex-basis: 0;max-width: 100%;}
  .start-${name} {justify-content: flex-start;text-align: start;}
  .center-${name} {justify-content: center;text-align: center;}
  .end-${name} {justify-content: flex-end;text-align: end;}
  .top-${name} {align-items: flex-start;}
  .middle-${name} {align-items: center;}
  .bottom-${name} {align-items: flex-end;}
  .around-${name} {justify-content: space-around;}
  .between-${name} {justify-content: space-between;}
  .first-${name} {order: -1;}
  .last-${name} {order: 1;}`;

  for (let i = 0; i < columns; i++) {
    const size = (((i + 1) * 100) / columns).toFixed(5);
    res += `.col-${name}-${i + 1}{flex-basis: ${size}%;max-width:${size}%;}`;

    const offset = ((i * 100) / columns).toFixed(5);
    res += `.col-${name}-offset-${i}{margin-left: ${offset}%;}`;

    res += `.order-${name}-${i + 1}{order:${i + 1};}`;
  }

  return res;
};
